import { render, staticRenderFns } from "./OpdrachtCard.vue?vue&type=template&id=63b970f8"
import script from "./OpdrachtCard.vue?vue&type=script&lang=ts"
export * from "./OpdrachtCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports